export { FollowUpSection, type FollowUpSectionProps } from "./FollowUpSection"
